
import { computed } from '@nuxtjs/composition-api'
import tinycolor from 'tinycolor2'

export default {
  name: 'ProductColorPicker',
  props: {
    colors: { type: Array, default: () => [] },
    activeColor: { type: String, default: '' },
    activeColorName: { type: String, default: '' },
    colorSelectionEnabled: { type: Boolean, default: true },
    colorNameCentered: { type: Boolean, default: false }
  },
  setup (props, { emit }) {
    const isDark = (value) => tinycolor(value).isDark()
    const isSelected = (color) => props.activeColor === color

    const selected = computed({
      get () {
        if (!Array.isArray(props.colors) || !props.colors.length) { return null }
        const idx = props.colors.indexOf(props.activeColor)
        return idx !== -1 ? idx : 0
      },
      set (idx) {
        const next = props.colors && props.colors[idx]
        if (next && next !== props.activeColor) { emit('colorChosen', next) }
      }
    })

    return { isDark, selected, isSelected }
  }
}
